import React, { Component } from 'react';
import styled, {keyframes} from 'styled-components';

const ripple = keyframes `
  from {
    box-shadow: 0 0 0 0 rgba(16, 148, 255, 0),
                0 0 0 0 rgba(16, 148, 255, 0),
                0 0 0 0 rgba(16, 148, 255, 0);
  }
  50% {
    box-shadow: 0 0 0 0 rgba(50, 154, 240, 0.1),
                0 0 0 1rem rgba(50, 154, 240, 0.1),
                0 0 0 2rem rgba(50, 154, 240, 0.1);
  }
  75% {
    box-shadow: 0 0 0 1rem rgba(50, 154, 240, 0.1),
                0 0 0 2rem rgba(50, 154, 240, 0.1),
                0 0 0 3rem rgba(16, 148, 255, 0);
  }
  to {
    box-shadow: 0 0 0 2rem rgba(16, 148, 255, 0),
                0 0 0 3rem rgba(16, 148, 255, 0),
                0 0 0 4rem rgba(16, 148, 255, 0);
  }
`;

const tour1Panel = keyframes `
  from, 50% { opacity: 0; transform: translate3d(20px, 0, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;

const tour1Point = keyframes `
  from, 50% { opacity: 0; transform: translate3d(-20px, 0, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;

const tour2Panel = keyframes `
  from, 50% { opacity: 0; transform: translate3d(0, 20px, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;

const tour2Point = keyframes `
  from, 50% { opacity: 0; transform: translate3d(0, -20px, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;

const tour3Panel = keyframes `
  from, 50% { opacity: 0; transform: translate3d(-20px, 0, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;

const tour3Point = keyframes `
  from, 50% { opacity: 0; transform: translate3d(20px, 0, 0) }
  to        { opacity: 1; transform: translate3d(0, 0, 0) }
`;

const NewComponentsContainer = styled.div`
  width: 100%;
  background: #f0f3f7;
  height: 592px;
  position: relative;

  h2.panel-title {
    color: #343A40;
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 2rem;
    margin-bottom: .5rem;
  }

  p {
    color: #343A40;
    font-family: -apple-system, BlinkMacSystemFont, "SF UI Text", San Francisco, Segoe UI, sans-serif;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 2rem;
  }

  a {
    color: #0087ff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  .tourpoint {
    background: #0087ff;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: absolute;
    top: 30px;
    left: -32px;
    animation: ${ripple} 2s linear infinite;
  }

  .pagination {
    color: #868E96;
    font-size: .875rem;
    line-height: 2rem;
    font-family: -apple-system, BlinkMacSystemFont, "SF UI Text", San Francisco, Segoe UI, sans-serif;
    display: block;
  }
  .panel {
    padding: 1.5rem;
    background: white;
    border-radius: 8px;
    z-index: 100;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
  }

  .panel-container {
    height: 12.5rem;
    width: 24rem;
    position: relative;
    border: 1px solid #DEE2E6;
    border-radius: 8px;
  	background: white;
  	box-shadow: 0 8px 16px 0 rgba(50, 73, 93, 0.2);
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    z-index: 2;


    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 1.5rem;
      left: -12px;
      height: 1.5rem;
      width: 1.5rem;
      background: inherit;
      transform: rotate(315deg);
      border-top: inherit;
      border-left: inherit;
      box-shadow: inherit;
    	border-radius: 4px 0 0 0;
    	z-index: 1;
    }
    &:before {
      box-shadow: 0 4px 8px 0 rgba(50, 50, 93, 0.1);
    }
    &:after {
    	z-index: 100;
    	box-shadow: none;
    }
  }
  .btn {
    cursor: pointer;
  	border: none;
    border-radius: 4px;
  	padding: 0;
    &.dismiss {
      position: absolute;
      right: 1.5rem;
      top: 1.5rem;
      background: none;
      pointer: cursor;
    }
  }

  .panel-buttons {
    position: absolute;
    bottom: 1.5rem;
    right: 1.5rem;
    .btn {
      box-shadow: 0 1px 3px 0 rgba(50, 50, 93, 0.1);
      color: #343A40;
      font-size: .875rem;
      font-weight: 600;
      line-height: 1rem;
      margin: 0 0 0 .5rem;
      padding: .5rem 1rem;
      &.btn-gray {
        background: linear-gradient(0deg, #F9FAFB, #FFFFFF);
        border: 1px solid #ADB5BD;
        &:hover {
          background: linear-gradient(180deg, #F9FAFB, #F4F6F8);
        }
        &:active {
          background: linear-gradient(180deg, #f4f6f8, #f4f6f8);
          box-shadow: 0 0 0 0 transparent, inset 0 1px 1px 0 rgba(99,115,129,.1), inset 0 1px 4px 0 rgba(99,115,129,.2);
        }
      }
      &.btn-blue {
    		background: linear-gradient(180deg, #3aa6ff, #008cff);
    		color: white;
        &:hover {
          background: linear-gradient(180deg, #008cff, #008cff);
        }
        &:active {
          background: linear-gradient(180deg, #0C6EBE, #0C6EBE);
          box-shadow: 0 0 0 0 transparent, inset 0 1px 1px 0 rgba(99,115,129,.1), inset 0 1px 4px 0 rgba(99,115,129,.2);
        }
    	}
      &:hover {

      }
    }
  }

  .reader-only {
    display: none;
  }
  .dismiss:hover svg path {
    fill: #000000;
  }

  #tourpoint1.panel-container {
    animation: ${tour1Panel} .5s linear;
    .steady {
      animation: ${tour1Point} .5s linear;
    }
  }

  #tourpoint2.panel-container {
      animation: ${tour2Panel} .5s linear;
      .steady {
        animation: ${tour2Point} .5s linear;
      }
      &:before,
      &:after {
        top: -12px;
        right: 180px;
        left: auto;
        border-bottom: none;
        border-right: inherit;
        border-left: none;
        border-top: inherit;
        border-radius: 0 0 4px 0;
        bottom: auto;
      }
      .tourpoint {
        top: -32px;
        right: 186px;
        bottom: auto;
        left: auto;
      }
  }

  #tourpoint3.panel-container {
      animation: ${tour3Panel} .5s linear;
      .steady {
        animation: ${tour3Point} .5s linear;
      }
      &:before,
      &:after {
        top: 1.5rem;
        right: -12px;
        left: auto;
        border-bottom: inherit;
        border-right: inherit;
        border-left: none;
        border-top: none;
        border-radius: 0 0 4px 0;
      }
      .tourpoint {
        right: -32px;
        left: auto;
      }
  }
`;


class NewComponents extends Component {
  constructor() {
    super();
    this.state = {
      tour1: true,
      tour2: false,
      tour3: false
    }
  }
  showTourTip1(e){
    e.preventDefault();
    this.setState({tour1: true});
    this.setState({tour2: false});
    this.setState({tour3: false})
  }

  showTourTip2(e){
    e.preventDefault();
    this.setState({tour1: false});
    this.setState({tour2: true});
    this.setState({tour3: false})
  }

  showTourTip3(e){
    e.preventDefault();
    this.setState({tour1: false});
    this.setState({tour2: false});
    this.setState({tour3: true})
  }

  render() {
    return (
        <NewComponentsContainer>
          {this.state.tour1 && <div id="tourpoint1" className="panel-container">
            <div className="steady"><div className="tourpoint"></div></div>
            <div className="panel">
              <div>
                <h2 className="panel-title">Tour Tip 1</h2>
                <nav className="panel-nav">
                  <button className="btn btn-link dismiss">
                    <a onClick={this.showTourTip1.bind(this)} href='#' aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10px" height="10px"><path fill="#ADB5BD" fillRule="nonzero" d="M3.586 5L.293 8.293c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0L5 6.414l3.293 3.293c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414L6.414 5l3.293-3.293c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0L5 3.586 1.707.293c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414L3.586 5z"/></svg></a>
                    <span className="reader-only">close modal</span>
                  </button>
                </nav>
                <div className="modal-body panel-content">
                  <p>Tours highlight and provide information about new and important features.</p>
                </div>
                <span className="pagination"><span className="count">1</span> of 3</span>
              </div>
              <div className="panel-buttons">
                <a onClick={this.showTourTip2.bind(this)} href='#'><button className="btn btn-blue">Next</button></a>
              </div>
            </div>
          </div>}
          {this.state.tour2 && <div id="tourpoint2" className="panel-container">
            <div className="steady"><div className="tourpoint"></div></div>
            <div className="panel">
              <div>
                <h2 className="panel-title">Tour Tip 2</h2>
                <nav className="panel-nav">
                  <button className="btn btn-link dismiss">
                    <a onClick={this.showTourTip1.bind(this)} href='#' aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10px" height="10px"><path fill="#ADB5BD" fillRule="nonzero" d="M3.586 5L.293 8.293c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0L5 6.414l3.293 3.293c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414L6.414 5l3.293-3.293c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0L5 3.586 1.707.293c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414L3.586 5z"/></svg></a>
                    <span className="reader-only">close modal</span>
                  </button>
                </nav>
                <div className="modal-body panel-content">
                  <p>Clicking "Next" will bring you to the next tourtip on the page. <a>Learn more</a></p>
                </div>
                <span className="pagination"><span className="count">2</span> of 3</span>
              </div>
              <div className="panel-buttons">
                <a onClick={this.showTourTip1.bind(this)} href='#'><button className="btn btn-gray">Back</button></a>
                <a onClick={this.showTourTip3.bind(this)} href='#'><button className="btn btn-blue">Next</button></a>
              </div>
            </div>
          </div>}
          {this.state.tour3 &&
            <div id="tourpoint3" className="panel-container">
              <div className="steady"><div className="tourpoint"></div></div>
              <div className="panel">
                <div>
                  <h2 className="panel-title">Tour Tip 3</h2>
                  <nav className="panel-nav">
                    <button className="btn btn-link dismiss">
                      <a onClick={this.showTourTip1.bind(this)} href='#' aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="10px" height="10px"><path fill="#ADB5BD" fillRule="nonzero" d="M3.586 5L.293 8.293c-.39.39-.39 1.024 0 1.414.39.39 1.024.39 1.414 0L5 6.414l3.293 3.293c.39.39 1.024.39 1.414 0 .39-.39.39-1.024 0-1.414L6.414 5l3.293-3.293c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.414 0L5 3.586 1.707.293c-.39-.39-1.024-.39-1.414 0-.39.39-.39 1.024 0 1.414L3.586 5z"/></svg></a>
                      <span className="reader-only">close modal</span>
                    </button>
                  </nav>
                  <div className="modal-body panel-content">
                    <p>Clicking "Finish" or the close button will end the tour. <a>Learn more</a></p>
                  </div>
                  <span className="pagination"><span className="count">3</span> of 3</span>
                </div>
                <div className="panel-buttons">
                  <a onClick={this.showTourTip2.bind(this)} href='#'><button className="btn btn-gray">Back</button></a>
                  <a onClick={this.showTourTip1.bind(this)} href='#'><button className="btn btn-blue">Finish</button></a>
                </div>
              </div>
            </div>}
        </NewComponentsContainer>
    );
  }
}

export default NewComponents;



// WEBPACK FOOTER //
// src/assets/ProgressComponents/NewComponents/NewComponents.js